module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "fullscreen": "",
      "persistent": "",
      "transition": "fade-transition"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('div', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "elevation-2"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "headline"
  }, [_vm._v("Create new Campaign")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', [(_vm.needCompany) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.company_options,
      "item-text": "name",
      "item-value": "id",
      "name": "state",
      "label": "Company",
      "filled": ""
    },
    model: {
      value: (_vm.campaign.companyID),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "companyID", $$v)
      },
      expression: "campaign.companyID"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.needClient) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "filled": "",
      "items": _vm.client_options,
      "label": "Client",
      "item-value": "id",
      "hide-details": "",
      "item-text": "name"
    },
    on: {
      "change": function($event) {
        return _vm.setClientData(_vm.campaign.clientID)
      }
    },
    model: {
      value: (_vm.campaign.clientID),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "clientID", $$v)
      },
      expression: "campaign.clientID"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "width": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-2"
  }, [_vm._v("\n                  Assigned Team\n                ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "grey lighten-3"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-subheader', [_vm._v("\n                        Dedicated Persons\n                      ")]), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "margin-top": "0px"
    }
  }), _vm._v(" "), _c('v-chip-group', {
    attrs: {
      "active-class": "primary--text",
      "column": ""
    },
    model: {
      value: (_vm.selectedDedicatedPersons),
      callback: function($$v) {
        _vm.selectedDedicatedPersons = $$v
      },
      expression: "selectedDedicatedPersons"
    }
  }, _vm._l((_vm.dedicatedPersons), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-2",
      attrs: {
        "value": item,
        "filter": ""
      }
    }, [_c('v-avatar', {
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                          " + _vm._s(item.firstName + ' ' + item.lastName) + "\n                        ")], 1)
  }), 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.supportingPersons.length > 0),
      expression: "supportingPersons.length > 0"
    }]
  }, [_vm._v("\n                       Supporting Persons\n                      ")]), _vm._v(" "), _c('v-divider', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.supportingPersons.length > 0),
      expression: "supportingPersons.length > 0"
    }],
    staticStyle: {
      "margin-top": "0px"
    }
  }), _vm._v(" "), _c('v-chip-group', {
    attrs: {
      "multiple": "",
      "active-class": "primary--text",
      "column": ""
    },
    model: {
      value: (_vm.selectedSupportingPersons),
      callback: function($$v) {
        _vm.selectedSupportingPersons = $$v
      },
      expression: "selectedSupportingPersons"
    }
  }, _vm._l((_vm.supportingPersons), function(item, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-2",
      attrs: {
        "value": item,
        "filter": ""
      }
    }, [_c('v-avatar', {
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                            " + _vm._s(item.firstName + ' ' + item.lastName) + "\n                          ")], 1)
  }), 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.campaignModelSections), function(section) {
    return _c('v-layout', {
      key: section.type,
      attrs: {
        "name": section.title
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-card', {
      attrs: {
        "width": "100%"
      }
    }, [_c('v-card-title', {
      staticClass: "title grey lighten-2"
    }, [_vm._v("\n                  " + _vm._s(section.title) + "\n                  "), _c('v-spacer'), _vm._v(" "), (section.type == _vm.campaignModelSectionType.VIDEO_BRIEF) ? _c('v-switch', {
      attrs: {
        "label": "Enable Video Brief"
      },
      model: {
        value: (_vm.showVideoBrief),
        callback: function($$v) {
          _vm.showVideoBrief = $$v
        },
        expression: "showVideoBrief"
      }
    }) : _vm._e(), _vm._v(" "), (section.type == _vm.campaignModelSectionType.EVENT_BRIEF) ? _c('v-switch', {
      attrs: {
        "label": "Enable Event Brief"
      },
      model: {
        value: (_vm.showEventBrief),
        callback: function($$v) {
          _vm.showEventBrief = $$v
        },
        expression: "showEventBrief"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', {
      staticClass: "grey lighten-3"
    }, [_c('v-container', [(section.type === _vm.campaignModelSectionType.BUDGET_ALLOCATION) ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [(_vm.selectedClient != null) ? _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "color": "info",
        "elevation": "4"
      },
      on: {
        "click": function($event) {
          _vm.viewClientDialog = true
        }
      }
    }, [_vm._v("\n                            Client Details\n                             "), _c('v-icon', {
      attrs: {
        "right": "",
        "dark": ""
      }
    }, [_vm._v("\n                              mdi-account-details\n                            ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((section.content), function(campaignField) {
      return _c('v-flex', {
        key: campaignField.name,
        attrs: {
          "xs12": "",
          "md6": "",
          "xl4": ""
        }
      }, [(campaignField.type === 'select') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-select', {
        attrs: {
          "solo": "",
          "name": campaignField.name,
          "items": _vm.IONumberItems,
          "item-text": "text",
          "item-value": "value",
          "placeholder": campaignField.placeholder
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'slider') ? _c('div', {
        class: {
          'has-error': _vm.$v.campaign[campaignField.name] && _vm.$v.campaign[campaignField.name].$error
        }
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-text-field', {
        attrs: {
          "hide-details": "",
          "placeholder": campaignField.placeholder,
          "solo": "",
          "type": "number"
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      }), _vm._v(" "), (_vm.selectedClient !== null) ? _c('div', {
        staticClass: "font-weight-light text-xs-right"
      }, [_vm._v(_vm._s(_vm.getUsage(_vm.campaign[campaignField.name], _vm.getMaxValueOf(campaignField.name))) + "% of Remaining amount")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'text') ? _c('div', {
        class: {
          'has-error': _vm.$v.campaign[campaignField.name] && _vm.$v.campaign[campaignField.name].$error
        }
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-text-field', {
        attrs: {
          "solo": "",
          "placeholder": campaignField.placeholder
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'date' && campaignField.name === 'startDate') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-menu', {
        attrs: {
          "close-on-content-click": false,
          "nudge-right": 40,
          "transition": "scale-transition",
          "offset-y": "",
          "min-width": "290px"
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-text-field', _vm._g({
              attrs: {
                "append-icon": "event",
                "readonly": "",
                "solo": ""
              },
              model: {
                value: (_vm.campaign[campaignField.name]),
                callback: function($$v) {
                  _vm.$set(_vm.campaign, campaignField.name, $$v)
                },
                expression: "campaign[campaignField.name]"
              }
            }, on))]
          }
        }], null, true),
        model: {
          value: (_vm.startCal),
          callback: function($$v) {
            _vm.startCal = $$v
          },
          expression: "startCal"
        }
      }, [_vm._v(" "), _c('v-date-picker', {
        attrs: {
          "type": "month"
        },
        on: {
          "input": function($event) {
            _vm.startCal = false
          }
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1)], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'date' && campaignField.name === 'endDate') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-menu', {
        ref: "monthPicker",
        refInFor: true,
        attrs: {
          "close-on-content-click": false,
          "nudge-right": 40,
          "transition": "scale-transition",
          "offset-y": "",
          "min-width": "290px"
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-text-field', _vm._g({
              attrs: {
                "append-icon": "event",
                "readonly": "",
                "solo": ""
              },
              model: {
                value: (_vm.campaign[campaignField.name]),
                callback: function($$v) {
                  _vm.$set(_vm.campaign, campaignField.name, $$v)
                },
                expression: "campaign[campaignField.name]"
              }
            }, on))]
          }
        }], null, true),
        model: {
          value: (_vm.endCal),
          callback: function($$v) {
            _vm.endCal = $$v
          },
          expression: "endCal"
        }
      }, [_vm._v(" "), _c('v-date-picker', {
        attrs: {
          "type": "month"
        },
        on: {
          "input": function($event) {
            _vm.endCal = false
          }
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1)], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'radio') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-radio-group', {
        attrs: {
          "row": ""
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      }, [_c('v-radio', {
        attrs: {
          "label": "by engagement",
          "value": "engagement"
        }
      }), _vm._v(" "), _c('v-radio', {
        attrs: {
          "label": "by contents",
          "value": "content"
        }
      })], 1)], 1) : _vm._e()])
    })], 2) : _vm._e(), _vm._v(" "), (
      (section.type === _vm.campaignModelSectionType.CAMPAIGN_SUMMARY) ||
      (section.type === _vm.campaignModelSectionType.INFLUENCER_SELECTION) ||
      (section.type === _vm.campaignModelSectionType.VIDEO_BRIEF && _vm.showVideoBrief)) ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, _vm._l((section.content), function(campaignField) {
      return _c('v-flex', {
        key: campaignField.name,
        attrs: {
          "xs12": "",
          "md12": "",
          "xl4": ""
        }
      }, [(campaignField.type === 'text' && campaignField.name === 'vertical') ? _c('div', {
        class: {
          'has-error': _vm.$v.campaign[campaignField.name] && _vm.$v.campaign[campaignField.name].$error
        }
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-autocomplete', {
        attrs: {
          "items": _vm.campaignVerticals,
          "item-text": "name",
          "item-value": "name",
          "hide-selected": "",
          "chips": "",
          "label": campaignField.placeholder,
          "multiple": "",
          "solo": "",
          "attach": ""
        },
        model: {
          value: (_vm.selectedCampaignVertical),
          callback: function($$v) {
            _vm.selectedCampaignVertical = $$v
          },
          expression: "selectedCampaignVertical"
        }
      })], 1) : (campaignField.type === 'text') ? _c('div', {
        class: {
          'has-error': _vm.$v.campaign[campaignField.name] && _vm.$v.campaign[campaignField.name].$error
        }
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-text-field', {
        attrs: {
          "solo": "",
          "placeholder": campaignField.placeholder
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'textarea') ? _c('div', {
        class: {
          'has-error': _vm.$v.campaign[campaignField.name] && _vm.$v.campaign[campaignField.name].$error
        }
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-textarea', {
        attrs: {
          "solo": "",
          "placeholder": campaignField.placeholder
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'combobox') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), (campaignField.name === 'targetAge') ? _c('v-combobox', {
        attrs: {
          "items": campaignField.items,
          "multiple": "",
          "solo": "",
          "chips": "",
          "placeholder": campaignField.placeholder
        },
        on: {
          "input": _vm.targetAgelimiter
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      }) : (campaignField.name === 'targetLocation') ? _c('v-autocomplete', {
        attrs: {
          "search-input": _vm.newCountry,
          "items": _vm.countries,
          "item-text": "name",
          "item-value": "code",
          "hide-selected": "",
          "multiple": "",
          "solo": "",
          "chips": "",
          "label": "Country",
          "dense": ""
        },
        on: {
          "update:searchInput": function($event) {
            _vm.newCountry = $event
          },
          "update:search-input": function($event) {
            _vm.newCountry = $event
          }
        },
        scopedSlots: _vm._u([{
          key: "selection",
          fn: function(ref) {
            var attrs = ref.attrs;
            var item = ref.item;
            var parent = ref.parent;
            var selected = ref.selected;

            return [(item === Object(item)) ? _c('v-chip', _vm._b({
              attrs: {
                "input-value": selected,
                "label": "",
                "small": ""
              }
            }, 'v-chip', attrs, false), [_c('span', {
              staticClass: "pr-2"
            }, [_vm._v("\n                                  " + _vm._s(item.name) + "\n                                ")]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": ""
              },
              on: {
                "click": function($event) {
                  return parent.selectItem(item)
                }
              }
            }, [_vm._v("\n                                  $delete\n                                ")])], 1) : _c('v-chip', _vm._b({
              attrs: {
                "input-value": selected,
                "label": "",
                "small": ""
              }
            }, 'v-chip', attrs, false), [_c('span', {
              staticClass: "pr-2"
            }, [_vm._v("\n                                  " + _vm._s(item) + "\n                                ")]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": ""
              },
              on: {
                "click": function($event) {
                  return parent.selectItem(item)
                }
              }
            }, [_vm._v("\n                                  $delete\n                                ")])], 1)]
          }
        }], null, true),
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      }) : _c('v-combobox', {
        attrs: {
          "items": campaignField.items,
          "multiple": "",
          "solo": "",
          "chips": "",
          "placeholder": campaignField.placeholder
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'select') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), (campaignField.name === 'name') ? _c('v-select', {
        attrs: {
          "solo": "",
          "name": campaignField.name,
          "items": campaignField.value,
          "item-text": "text",
          "item-value": "value"
        },
        on: {
          "change": function($event) {
            return _vm.changeCampaignName(_vm.campaign[campaignField.name])
          }
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      }) : _c('v-select', {
        attrs: {
          "solo": "",
          "name": campaignField.name,
          "items": campaignField.value,
          "item-text": "text",
          "item-value": "value"
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'autocomplete') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-autocomplete', {
        attrs: {
          "items": campaignField.value,
          "item-text": "text",
          "item-value": "name",
          "hide-selected": "",
          "chips": "",
          "label": campaignField.placeholder,
          "multiple": "",
          "solo": "",
          "attach": ""
        },
        scopedSlots: _vm._u([{
          key: "selection",
          fn: function(ref) {
            var attrs = ref.attrs;
            var item = ref.item;
            var parent = ref.parent;
            var selected = ref.selected;

            return [(item === Object(item)) ? _c('v-chip', _vm._b({
              attrs: {
                "input-value": selected,
                "label": "",
                "small": ""
              }
            }, 'v-chip', attrs, false), [_c('span', {
              staticClass: "pr-2"
            }, [_vm._v("\n                                  " + _vm._s(item.text) + "\n                                ")]), _vm._v(" "), _c('v-icon', {
              attrs: {
                "small": ""
              },
              on: {
                "click": function($event) {
                  return parent.selectItem(item)
                }
              }
            }, [_vm._v("\n                                  $delete\n                                ")])], 1) : _vm._e()]
          }
        }], null, true),
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'chips') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('draggable', {
        staticClass: "row no-gutters flex-wrap flex-row fill-height",
        staticStyle: {
          "width": "100%"
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      }, _vm._l((_vm.campaign[campaignField.name]), function(item, index) {
        return _c('v-chip', {
          key: index,
          staticClass: "ma-2",
          attrs: {
            "value": item,
            "filter": ""
          }
        }, [_vm._v("\n                              " + _vm._s(item.text) + "\n                            ")])
      }), 1)], 1) : _vm._e(), _vm._v(" "), (campaignField.type == 'upload') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('div', {
        staticClass: "canvas-image-input"
      }, [_c('input', {
        ref: "files",
        refInFor: true,
        attrs: {
          "type": "file"
        },
        on: {
          "change": function($event) {
            return _vm.processImage($event, 'canvas', null, null, 'canvas')
          }
        }
      })])]) : _vm._e(), _vm._v(" "), (campaignField.type === 'date' && campaignField.name === 'video_live_date') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-menu', {
        attrs: {
          "close-on-content-click": false,
          "nudge-right": 40,
          "transition": "scale-transition",
          "offset-y": "",
          "min-width": "290px"
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('v-text-field', _vm._g({
              attrs: {
                "append-icon": "event",
                "readonly": "",
                "solo": ""
              },
              model: {
                value: (_vm.campaign[campaignField.name]),
                callback: function($$v) {
                  _vm.$set(_vm.campaign, campaignField.name, $$v)
                },
                expression: "campaign[campaignField.name]"
              }
            }, on))]
          }
        }], null, true),
        model: {
          value: (_vm.videoDateDialog),
          callback: function($$v) {
            _vm.videoDateDialog = $$v
          },
          expression: "videoDateDialog"
        }
      }, [_vm._v(" "), _c('v-date-picker', {
        on: {
          "input": function($event) {
            _vm.videoDateDialog = false
          }
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1)], 1) : _vm._e()])
    }), 1) : _vm._e(), _vm._v(" "), (section.type === _vm.campaignModelSectionType.CONTENT_ANGLE) ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, _vm._l((section.content), function(campaignField) {
      return _c('v-flex', {
        key: campaignField.name,
        attrs: {
          "xs12": ""
        }
      }, [(campaignField.type === 'select') ? _c('div', {
        staticClass: "action-required"
      }, [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-select', {
        attrs: {
          "solo": "",
          "name": campaignField.name,
          "items": campaignField.value,
          "item-text": "text",
          "item-value": "value"
        },
        model: {
          value: (_vm.campaign[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign, campaignField.name, $$v)
          },
          expression: "campaign[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'multiple_options') ? _c('div', [_vm._l((_vm.campaign[campaignField.name]), function(option, optionIndex) {
        return _c('div', {
          key: optionIndex
        }, [_c('h4', [_vm._v("\n                              " + _vm._s(campaignField.label) + " " + _vm._s(optionIndex + 1) + "\n                              "), (_vm.campaign[campaignField.name].length > 1) ? _c('v-btn', {
          attrs: {
            "text": "",
            "icon": "",
            "color": "red"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteOption(campaignField.name, optionIndex)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash ims-text-error"
        })]) : _vm._e()], 1), _vm._v(" "), _c('v-container', [_c('v-layout', {
          attrs: {
            "wrap": ""
          }
        }, _vm._l((campaignField.template), function(optionField, i) {
          return _c('v-flex', {
            key: i,
            attrs: {
              "xs12": ""
            }
          }, [(optionField.type == 'text') ? _c('div', [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('v-text-field', {
            attrs: {
              "solo": "",
              "placeholder": optionField.placeholder
            },
            model: {
              value: (_vm.campaign[campaignField.name][optionIndex][optionField.name]),
              callback: function($$v) {
                _vm.$set(_vm.campaign[campaignField.name][optionIndex], optionField.name, $$v)
              },
              expression: "campaign[campaignField.name][optionIndex][optionField.name]"
            }
          })], 1) : _vm._e(), _vm._v(" "), (optionField.type == 'textarea') ? _c('div', [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), _c('v-textarea', {
            attrs: {
              "solo": "",
              "placeholder": optionField.placeholder
            },
            model: {
              value: (_vm.campaign[campaignField.name][optionIndex][optionField.name]),
              callback: function($$v) {
                _vm.$set(_vm.campaign[campaignField.name][optionIndex], optionField.name, $$v)
              },
              expression: "campaign[campaignField.name][optionIndex][optionField.name]"
            }
          })], 1) : _vm._e(), _vm._v(" "), (optionField.type == 'multiple_options') ? _c('div', [_vm._l((_vm.campaign[campaignField.name][optionIndex][optionField.name]), function(secondOption, secondOptionIndex) {
            return _c('div', {
              key: secondOptionIndex
            }, [_c('h4', [_vm._v("\n                                          Required Action " + _vm._s(secondOptionIndex + 1) + "\n                                          "), (_vm.campaign[campaignField.name][optionIndex][optionField.name].length > 1) ? _c('v-btn', {
              attrs: {
                "text": "",
                "icon": "",
                "color": "red"
              },
              on: {
                "click": function($event) {
                  $event.stopPropagation();
                  return _vm.deleteSecondOption(campaignField.name, optionIndex, optionField.name, secondOptionIndex)
                }
              }
            }, [_c('i', {
              staticClass: "fa fa-trash ims-text-error"
            })]) : _vm._e()], 1), _vm._v(" "), _vm._l((optionField.template), function(optionField2, optionIndex2) {
              return _c('v-layout', {
                key: optionIndex2,
                attrs: {
                  "wrap": ""
                }
              }, _vm._l((optionField2), function(format, i) {
                return _c('v-flex', {
                  key: i,
                  attrs: {
                    "xs6": ""
                  }
                }, [(format.type == 'text') ? _c('div', [_c('label', [_vm._v(_vm._s(format.label))]), _vm._v(" "), _c('v-text-field', {
                  attrs: {
                    "solo": "",
                    "placeholder": format.placeholder
                  },
                  model: {
                    value: (_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]),
                    callback: function($$v) {
                      _vm.$set(_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex], format.name, $$v)
                    },
                    expression: "campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]"
                  }
                })], 1) : _vm._e(), _vm._v(" "), (format.type == 'textarea') ? _c('div', [_c('label', [_vm._v(_vm._s(format.label))]), _vm._v(" "), _c('v-textarea', {
                  attrs: {
                    "solo": "",
                    "placeholder": format.placeholder
                  },
                  model: {
                    value: (_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]),
                    callback: function($$v) {
                      _vm.$set(_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex], format.name, $$v)
                    },
                    expression: "campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]"
                  }
                })], 1) : _vm._e(), _vm._v(" "), (format.type === 'combobox') ? _c('div', [_c('label', [_vm._v(_vm._s(format.label))]), _vm._v(" "), _c('v-combobox', {
                  attrs: {
                    "items": format.items,
                    "multiple": "",
                    "solo": "",
                    "chips": "",
                    "placeholder": format.placeholder,
                    "append-icon": ""
                  },
                  model: {
                    value: (_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]),
                    callback: function($$v) {
                      _vm.$set(_vm.campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex], format.name, $$v)
                    },
                    expression: "campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]"
                  }
                })], 1) : _vm._e(), _vm._v(" "), (format.type == 'upload') ? _c('div', [_c('label', [_vm._v(_vm._s(format.label))]), _vm._v(" "), _c('div', {
                  staticClass: "image-input-container",
                  attrs: {
                    "id": 'optionImages_' + optionIndex + '_' + secondOptionIndex,
                    "data-index": optionIndex
                  }
                }, [_c('div', {
                  staticClass: "input-group pb-2",
                  attrs: {
                    "id": 'input_group_0_' + optionIndex + '_' + secondOptionIndex
                  }
                }, [_c('label', {
                  staticClass: "pr-2"
                }, [_c('input', {
                  attrs: {
                    "type": "radio",
                    "id": 'radio_image_' + optionIndex + '_' + secondOptionIndex,
                    "name": 'type_' + optionIndex + '_' + secondOptionIndex,
                    "value": "image",
                    "checked": "true"
                  },
                  on: {
                    "change": function($event) {
                      return _vm.changeOptionType('0_' + optionIndex + '_' + secondOptionIndex, 'image')
                    }
                  }
                }), _vm._v(" Image\n                                                  ")]), _vm._v(" "), _c('label', [_c('input', {
                  attrs: {
                    "type": "radio",
                    "id": 'radio_link_' + optionIndex + '_' + secondOptionIndex,
                    "name": 'type_' + optionIndex + '_' + secondOptionIndex,
                    "value": "link"
                  },
                  on: {
                    "change": function($event) {
                      return _vm.changeOptionType('0_' + optionIndex + '_' + secondOptionIndex, 'link')
                    }
                  }
                }), _vm._v(" Video Link\n                                                  ")]), _vm._v(" "), _c('div', [_c('input', {
                  staticClass: "custom-input",
                  staticStyle: {
                    "display": "none"
                  },
                  attrs: {
                    "type": "text",
                    "id": 'video_link_0_' + optionIndex + '_' + secondOptionIndex
                  },
                  on: {
                    "keyup": function($event) {
                      return _vm.changeVideoLink('angel', optionIndex, secondOptionIndex, 0 + '_' + optionIndex + '_' + secondOptionIndex)
                    }
                  }
                })]), _vm._v(" "), _c('div', {
                  staticClass: "image-input",
                  attrs: {
                    "id": 'img_upload_0_' + optionIndex + '_' + secondOptionIndex
                  }
                }, [_c('input', {
                  ref: "files",
                  refInFor: true,
                  attrs: {
                    "type": "file"
                  },
                  on: {
                    "change": function($event) {
                      return _vm.processImage($event, 'angel', optionIndex, secondOptionIndex, 0 + '_' + optionIndex + '_' + secondOptionIndex)
                    }
                  }
                })])]), _vm._v(" "), _c('button', {
                  staticClass: "btn btn-link btn-link-danger btn-remove-input",
                  attrs: {
                    "type": "button"
                  },
                  on: {
                    "click": function($event) {
                      $event.preventDefault();
                      return _vm.removeImage(optionIndex, 0 + '_' + optionIndex + '_' + secondOptionIndex)
                    }
                  }
                }, [_vm._v("Remove")])]), _vm._v(" "), _c('button', {
                  staticClass: "btn btn-default btn-sm btn-add-more-image",
                  attrs: {
                    "type": "button"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.addMoreImage(optionIndex, secondOptionIndex)
                    }
                  }
                }, [_vm._v("+ Add more image")])]) : _vm._e()])
              }), 1)
            })], 2)
          }), _vm._v(" "), _c('v-btn', {
            staticClass: "default",
            attrs: {
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.addSecondOption(campaignField.name, optionIndex, optionField.name)
              }
            }
          }, [_vm._v("+ Add Required Action")])], 2) : _vm._e()])
        }), 1)], 1)], 1)
      }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', [_c('v-btn', {
        staticClass: "secondary",
        attrs: {
          "small": ""
        },
        on: {
          "click": function($event) {
            return _vm.addOption(campaignField.name)
          }
        }
      }, [_vm._v("Add new Concept")])], 1)], 2) : _vm._e()])
    }), 1) : _vm._e(), _vm._v(" "), (section.type === _vm.campaignModelSectionType.EVENT_BRIEF && _vm.showEventBrief) ? _c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, _vm._l((section.content), function(campaignField) {
      return _c('v-flex', {
        key: campaignField.name,
        attrs: {
          "xs12": ""
        }
      }, [(campaignField.type === 'textarea') ? _c('div', [_c('label', [_vm._v(_vm._s(campaignField.label))]), _vm._v(" "), _c('v-textarea', {
        attrs: {
          "solo": "",
          "placeholder": campaignField.placeholder
        },
        model: {
          value: (_vm.campaign.eventBrief[campaignField.name]),
          callback: function($$v) {
            _vm.$set(_vm.campaign.eventBrief, campaignField.name, $$v)
          },
          expression: "campaign.eventBrief[campaignField.name]"
        }
      })], 1) : _vm._e(), _vm._v(" "), (campaignField.type === 'multiple_options') ? _c('div', [_c('h4', [_vm._v("\n                            " + _vm._s(campaignField.label) + "\n                          ")]), _vm._v(" "), _vm._l((_vm.campaign.eventBrief[campaignField.name]), function(option, optionIndex) {
        return _c('div', {
          key: optionIndex
        }, [_c('v-container', [_c('v-layout', {
          attrs: {
            "wrap": ""
          }
        }, _vm._l((campaignField.template), function(optionField, i) {
          return _c('v-flex', {
            key: i,
            attrs: {
              "xs12": "",
              "md3": ""
            }
          }, [(optionField.type == 'text') ? _c('div', [_c('label', [_vm._v(_vm._s(optionField.label))]), _vm._v(" "), (_vm.campaign.eventBrief[campaignField.name].length > 1) ? _c('v-icon', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (optionField.name === 'attendeeName'),
              expression: "optionField.name === 'attendeeName'"
            }],
            attrs: {
              "text": "",
              "icon": "",
              "color": "red"
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.deleteAttendee(campaignField.name, optionIndex)
              }
            }
          }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), _c('v-text-field', {
            attrs: {
              "solo": "",
              "placeholder": optionField.placeholder
            },
            model: {
              value: (_vm.campaign.eventBrief[campaignField.name][optionIndex][optionField.name]),
              callback: function($$v) {
                _vm.$set(_vm.campaign.eventBrief[campaignField.name][optionIndex], optionField.name, $$v)
              },
              expression: "campaign.eventBrief[campaignField.name][optionIndex][optionField.name]"
            }
          })], 1) : _vm._e()])
        }), 1)], 1)], 1)
      }), _vm._v(" "), _c('div', [_c('v-btn', {
        staticClass: "secondary",
        attrs: {
          "small": ""
        },
        on: {
          "click": function($event) {
            return _vm.addAttendee(campaignField.name)
          }
        }
      }, [_vm._v("Add an Attendee")])], 1)], 2) : _vm._e(), _vm._v(" "), (campaignField.type === 'template') ? _c('div', [_c('h4', [_vm._v("\n                            " + _vm._s(campaignField.label) + "\n                          ")]), _vm._v(" "), _c('v-container', [_c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, _vm._l((campaignField.template), function(templateField, i) {
        return _c('v-flex', {
          key: i,
          attrs: {
            "xs12": "",
            "md4": ""
          }
        }, [(templateField.type == 'text') ? _c('div', [_c('label', [_vm._v(_vm._s(templateField.label))]), _vm._v(" "), _c('v-text-field', {
          attrs: {
            "solo": "",
            "placeholder": templateField.placeholder
          },
          model: {
            value: (_vm.campaign.eventBrief[campaignField.name][templateField.name]),
            callback: function($$v) {
              _vm.$set(_vm.campaign.eventBrief[campaignField.name], templateField.name, $$v)
            },
            expression: "campaign.eventBrief[campaignField.name][templateField.name]"
          }
        })], 1) : _vm._e(), _vm._v(" "), (templateField.type === 'radioButton') ? _c('div', [_c('label', [_vm._v(_vm._s(templateField.label))]), _vm._v(" "), _c('v-checkbox', {
          attrs: {
            "label": _vm.campaign.eventBrief[campaignField.name][templateField.name] ? 'Yes' : 'No'
          },
          model: {
            value: (_vm.campaign.eventBrief[campaignField.name][templateField.name]),
            callback: function($$v) {
              _vm.$set(_vm.campaign.eventBrief[campaignField.name], templateField.name, $$v)
            },
            expression: "campaign.eventBrief[campaignField.name][templateField.name]"
          }
        })], 1) : _vm._e(), _vm._v(" "), (templateField.type === 'date' && templateField.name === 'eventDate') ? _c('div', [_c('label', [_vm._v(_vm._s(templateField.label))]), _vm._v(" "), _c('v-menu', {
          attrs: {
            "close-on-content-click": false,
            "nudge-right": 40,
            "transition": "scale-transition",
            "offset-y": "",
            "min-width": "290px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-text-field', _vm._g({
                attrs: {
                  "append-icon": "event",
                  "readonly": "",
                  "solo": ""
                },
                model: {
                  value: (_vm.campaign.eventBrief[campaignField.name][templateField.name]),
                  callback: function($$v) {
                    _vm.$set(_vm.campaign.eventBrief[campaignField.name], templateField.name, $$v)
                  },
                  expression: "campaign.eventBrief[campaignField.name][templateField.name]"
                }
              }, on))]
            }
          }], null, true),
          model: {
            value: (_vm.eventDateDialog),
            callback: function($$v) {
              _vm.eventDateDialog = $$v
            },
            expression: "eventDateDialog"
          }
        }, [_vm._v(" "), _c('v-date-picker', {
          on: {
            "input": function($event) {
              _vm.eventDateDialog = false
            }
          },
          model: {
            value: (_vm.campaign.eventBrief[campaignField.name][templateField.name]),
            callback: function($$v) {
              _vm.$set(_vm.campaign.eventBrief[campaignField.name], templateField.name, $$v)
            },
            expression: "campaign.eventBrief[campaignField.name][templateField.name]"
          }
        })], 1)], 1) : _vm._e(), _vm._v(" "), (templateField.type === 'textarea') ? _c('div', [_c('label', [_vm._v(_vm._s(templateField.label))]), _vm._v(" "), _c('v-textarea', {
          attrs: {
            "solo": "",
            "placeholder": templateField.placeholder
          },
          model: {
            value: (_vm.campaign.eventBrief[campaignField.name][templateField.name]),
            callback: function($$v) {
              _vm.$set(_vm.campaign.eventBrief[campaignField.name], templateField.name, $$v)
            },
            expression: "campaign.eventBrief[campaignField.name][templateField.name]"
          }
        })], 1) : _vm._e()])
      }), 1)], 1)], 1) : _vm._e()])
    }), 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('v-btn', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "disabled": _vm.submitting
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createCampaign.apply(null, arguments)
      }
    }
  }, [(_vm.submitting) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }) : _vm._e(), _vm._v("\n            Save Changes\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.submitting,
      "can-cancel": false,
      "is-full-page": true
    },
    on: {
      "update:active": function($event) {
        _vm.submitting = $event
      }
    }
  })], 1), _vm._v(" "), _c('view-client-modal', {
    attrs: {
      "clientData": _vm.viewClientData
    },
    model: {
      value: (_vm.viewClientDialog),
      callback: function($$v) {
        _vm.viewClientDialog = $$v
      },
      expression: "viewClientDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7de3e285"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/CreateCampaignModal.vue
// module id = 2219
// module chunks = 0